// extracted by mini-css-extract-plugin
export default {"backdrop":"mediaPreview_backdrop__hcGuK","box":"mediaPreview_box__Vsz4t","box__img":"mediaPreview_box__img__adlBz","box__btn":"mediaPreview_box__btn__M8g3T"};